import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Amplify, { Auth, Analytics } from "aws-amplify";
import awsconfig, {analyticsConfig} from "../../awsConfig/awsConfig";

import { onAuthorizeSuccess, onAuthorizeFail } from "../../redux/slices/login";
import bloombergAuth from "../../auth/utils/bloombergAuth";
import { setNotInitialLoad } from "../../redux/slices/display";

const useAuth = (loginAttempts) => {
  const dispatch = useDispatch();
  Amplify.configure(awsconfig);
  Analytics.configure(analyticsConfig)
  
  const isInitialLoad = useSelector(({ display }) => display.isInitialLoad);

  useEffect(() => {
    async function authenticate() {
      try {
        await Auth.currentSession();
        await bloombergAuth(Auth);
        dispatch(onAuthorizeSuccess());
      } catch (error) {
        console.log(error);
        dispatch(onAuthorizeFail());
      }
    }
    authenticate();
  }, [dispatch, loginAttempts, isInitialLoad]);

  const isAuth = useSelector(({ login }) => login.isAuthorised);

  useEffect(() => {
    if (isInitialLoad && isAuth) {
      dispatch(setNotInitialLoad());
    }
  }, [dispatch, isAuth, isInitialLoad]);

  return isAuth;
};

export default useAuth;
